import '../App.css';
import { SiLinkedin } from "react-icons/si";
import { SiGithub } from "react-icons/si";
import { FaStackOverflow } from "react-icons/fa";
import { FaMedium } from "react-icons/fa";
import { FaPhone } from "react-icons/fa";
import { FaEmail } from "react-icons/fa";
import { AiFillMail } from "react-icons/ai";
import { FaGlobeEurope } from "react-icons/fa";
import { BiCurrentLocation } from "react-icons/bi";
import { FaLocationArrow } from 'react-icons/fa';
import ContactButton from './ContactButton';
import { useState, useEffect } from 'react';
import axios from 'axios';

function Contact({ contactRef }) {
   
    const [submit, setSubmit] = useState(false);
    const [formData, setFormData] = useState({});

    const handleSubmit = event => {
        event.preventDefault();
        console.log(formData);
        try {

            axios.post('https://portfolio-mail-service-neeraj.herokuapp.com/sendMessage', {
                email: formData.email,
                message: formData.message,
              })
              .then(function (response) {
                alert("thank you for your message!");
              })
              .catch(function (error) {
                console.log(error);
              });


        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className='Contact-Container' ref={contactRef}>
            <div className='Contact-Left'>
                <h1>Contact</h1>
                <p>Let's get to know each other!</p>
                <div className='Left-Banner-Info'>

                    <div className='Left-Banner-Up'>
                        <div className='Contact-Info Left-Banner-Items'><SiLinkedin /><a href={'https://www.linkedin.com/in/neeraj-malwal-40070a1a7/'} target={'_blank'}>Linkedin</a></div>
                        <div className='Contact-Info Left-Banner-Items'><SiGithub /><a href={'https://github.com/neerajmasai'} target={'_blank'}>Github</a></div>
                        <div className='Contact-Info Left-Banner-Items'><FaStackOverflow /><a href={'https://stackoverflow.com/users/12056503/neeraj-malwal'} target={'_blank'}>Stack Overflow</a></div>
                        <div className='Contact-Info Left-Banner-Items'><FaMedium /><a href={'https://medium.com/@neeraj_fw10_110/how-i-made-my-first-website-clone-and-how-you-can-too-4f20bad0a4'} target={'_blank'}>Medium</a></div>
                    </div>

                    <div className='Left-Banner-Down'>
                        <div className='Contact-Info Left-Banner-Items'><FaPhone /><a href='#'>Phone: +91 9588686878</a></div>
                        <div className='Contact-Info Left-Banner-Items'><AiFillMail /><a href='#'>Email: neerajmalwal10@gmail.com</a></div>
                        <div className='Contact-Info Left-Banner-Items'><FaGlobeEurope /><a href='#'>Speaks: English, Hindi and Marathi</a></div>
                        <div className='Contact-Info Left-Banner-Items'><FaLocationArrow /><a href='#'>Located in: Pune, India</a></div>
                    </div>

                </div>
            </div>
            <div className='Contact-Right'>
                <h2>Want to know more about me? Send a message:</h2>
                <p>Your messages will be sent directly to my mailbox, I usually respond within 24 hours, thanks for being patient!</p>

                <form className='Contact-Form' onSubmit={handleSubmit}>
                    <input type="email" placeholder='Drop your mail here...' onChange={(event) => {
                        setFormData({ ...formData, email: event.target.value })
                    }} />
                    <input type="text" placeholder='Write your message here...' onChange={event => {
                        setFormData({ ...formData, message: event.target.value })
                    }} />
                    <div className='Contact-Button'>
                        <button type='submit'>
                            Send
                        </button>
                    </div>
                </form>

            </div>
        </div>
    )
}

export default Contact;